import { EPublishOfferErrorCode } from '../../../redux/reducers';
import { IMappers } from '../../../repositories/monolith-python/v3/publish-offer';
import { IPublishOfferFail, IPublishOfferSuccess } from '../types';
import { mapErrors } from './mapErrors';
import { mapPublishOfferData } from './mapPublishOfferData';

export const mappers: IMappers<IPublishOfferSuccess, IPublishOfferFail> = {
  200: response => ({
    success: true,
    payload: mapPublishOfferData(response),
  }),
  400: ({ data, status }) => ({
    success: false,
    statusCode: 400,
    payload: {
      errorCode: status as string as EPublishOfferErrorCode,
      errorMessage: null,
      errors: mapErrors(data.errors),
    },
  }),
};
